import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPenToSquare,
  faSave,
  faCheck,
  faXmark,
  faFileLines,
  faCloudArrowUp
} from '@fortawesome/free-solid-svg-icons';
import api from "@/auth/api";
import { alertSuccess, alertError } from "@/components/Alert";

const DonationTable = ({
  headers,
  rows,
  editRowId,
  editedData,
  handleEdit,
  handleSave,
  handleCancel,
  handleChange,
  editableFields,
  handleLog,
  hideChangeLog,
  fetchData,
  agencyList,
  countryList
}) => {

  const handleUploadImage = async (row, file) => {
    try {
      const formData = new FormData();
      formData.append("DonationImage", file);
      formData.append("id", row.id);
      const response = await api.patch(`/redeem/panel/donation`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      alertSuccess("Image uploaded successfully");
      fetchData();
    } catch (error) {
      console.error("Image upload failed:", error);
      alertError(error?.response?.data?.errors || "Upload failed");
    }
  };

  return (
    <div className="tableContainer max-w-full w-[90vw]">
      <table className="table text-xs w-[88vw]" role="table">
        <thead className="stickyHeader bg-[var(--mainCol)] text-white">
          <tr>
            {headers?.map((header, index) => (
              <th className="p-1 text-left border" key={index}>
                {header.toUpperCase()}
              </th>
            ))}
            <th style={{ background: "var(--mainCol)" }} className="p-1 text-left border stickyActionColumn z-100">ACTION</th>
          </tr>
        </thead>
        <tbody>
          {rows?.map((row) => (
            <tr key={row.id}>
              {headers.map((header) => (
                <td key={header} className="p-3 border">
                  {editRowId === row.id && editableFields?.includes(header) ? (
                    header === 'active' || header === 'status' || header === 'is_read' ||
                    header === 'is_Finshed' || header === 'is_Start' || header === 'queryResolve' || header === 'multipleOfPoints' ? (
                      <div className="cursor-pointer flex justify-center">
                        {editedData[header] === true && (
                          <FontAwesomeIcon onClick={(e) => handleChange(e, header, true)} color="var(--green_Main)" icon={faCheck} />
                        )}
                        {editedData[header] === false && (
                          <FontAwesomeIcon onClick={(e) => handleChange(e, header, false)} color="indianred" icon={faXmark} />
                        )}
                      </div>
                    ) : header === 'agency' ? (
                      <select
                        value={editedData[header] || ''}
                        onChange={(e) => handleChange(e, header)}
                        className="w-full p-1 border"
                      >
                        <option value="" disabled>Select agency</option>
                        {agencyList.map((m) => (
                          <option key={m.id} value={m.agencyName}>{m.agencyName}</option>
                        ))}
                      </select>
                    ) : header === 'country' ? (
                      <select
                        value={editedData[header] || ''}
                        onChange={(e) => handleChange(e, header)}
                        className="w-full p-1 border"
                      >
                        <option value="">Select Country</option>
                        {countryList?.map((country, idx) => (
                          <option key={idx} value={country.title}>{country.title}</option>
                        ))}
                      </select>
                    ) : header === 'detailFirstPage' || header === 'detailEndPage' ? (
                        <textarea
                        value={editedData[header] || ''}
                        onChange={(e) => handleChange(e, header)}
                        className="w-full p-1 border font-mono text-[11px] h-20"
                      />
                    ) : (
                      <input
                        type="text"
                        value={editedData[header] || ''}
                        onChange={(e) => handleChange(e, header)}
                        onKeyUp={(e) => e.key === 'Enter' && handleSave()}
                        className="w-full p-1 border"
                      />
                    )
                  ) : (
                    row[header] === true ? (
                      <FontAwesomeIcon className="ml-2" color="var(--green_Main)" icon={faCheck} />
                    ) : row[header] === false ? (
                      <FontAwesomeIcon className="ml-2" color="indianred" icon={faXmark} />
                    ) : header === "DonationImage" && row[header] ? (
                      <>
                        <img src={row[header]} alt="background" className="max-h-16 max-w-[120px] object-contain mb-2 mx-auto" />
                        <label htmlFor={`fileUpload-${row.id}`} className="text-center text-nowrap mt-10 cursor-pointer">
                          <FontAwesomeIcon icon={faCloudArrowUp} /> Upload new Image
                        </label>
                        <input
                          id={`fileUpload-${row.id}`}
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleUploadImage(row, e.target.files[0])}
                          className="mb-3 hidden"
                        />
                      </>
                    ) : header === 'detailFirstPage' || header === 'detailEndPage' ? (
                      <pre className="whitespace-pre-wrap break-words text-[10px] font-mono">
                        {JSON.stringify(row[header], null, 2)}
                      </pre>
                    ) : (
                      String(row[header])
                    )
                  )}
                </td>
              ))}
              <td className="p-2 border stickyActionColumn">
                {editRowId === row.id ? (
                  <div className="flex justify-center">
                    <FontAwesomeIcon
                      className="p-2 cursor-pointer"
                      color="#67a97b"
                      onClick={handleSave}
                      icon={faSave}
                    />
                    <FontAwesomeIcon
                      className="p-2 cursor-pointer"
                      color="indianred"
                      onClick={handleCancel}
                      icon={faXmark}
                    />
                  </div>
                ) : (
                  <div className="flex justify-center z-100">
                    <FontAwesomeIcon
                      className="cursor-pointer"
                      onClick={() => handleEdit(row.id)}
                      icon={faPenToSquare}
                    />
                    {!hideChangeLog && (
                      <FontAwesomeIcon className="ml-2 cursor-pointer" onClick={() => handleLog(row.id)} icon={faFileLines} />
                    )}
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DonationTable;
